import { ReconciliationState } from "@/vuex/modules/inventory/reconciliation/reconciliation.types";
import { RootState } from "@/vuex/types";
import { Module } from "vuex";
import { actions } from "./reconciliation.actions";
import { getters } from "./reconciliation.getters";
import { mutations } from "./reconciliation.mutations";
import { state } from "./reconciliation.state";

const namespaced: boolean = true;
export const ReconciliationModule: Module<ReconciliationState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
